export function dealwithOtherFilter(data: any) {
  const {
    channel_comments,
    channel_news,
    channel_securitys,
    channel_social,
    subcategories,
    categories,
    ...otherFilter
  } = data || {};
  return otherFilter;
}
